var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isMobile)?_c('v-btn',{attrs:{"flat":"","icon":"","color":"info"},on:{"click":_vm.editGuest}},[_c('fa-icon',{class:'is-steps-icon',attrs:{"icon":"pencil-alt","size":"lg"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }